(async () => {
  if (!customElements.get('product-media')) {
    const { Swiper } = await import('swiper');
    const { Navigation } = await import('swiper/modules');
    const { Fancybox } = await import('@fancyapps/ui');

    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        this.swiper();
        this.fancybox();
      }

      swiper() {
        // Check if Swiper exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        // Get swiper element
        this.swiperElement = this.querySelector('[data-product-media-swiper]');

        // Swiper options
        this.swiperOptions = {
          modules: [Navigation],
          direction: 'horizontal',
          spaceBetween: 4,
          slidesPerView: 1.145,
          breakpoints: {
            480: {
              slidesPerView: 1.5,
            },
          },
        };

        // Init swiper
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // Rebuild Swiper in design mode
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
        });
      }
    }

    window.ProductMedia = ProductMedia;

    customElements.define('product-media', ProductMedia);
  }
})();
